import React, { useEffect } from "react";
import LandingPage from "./container/LandingPage";
import AdminDashboard from "../src/container/AdminDashboard";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import LoginPage from "./auth/login";
import Layout from "./components/Components/Layout";
import Missing from "./components/Components/Missing";
import RequireAuth from "./components/Components/RequireAuth";
import OrganizationGuestRegistration from "./components/Dashboard/OrganizationGuestRegistration";
import RelationGuest from "./components/Dashboard/RelationGuestRegistration";
import {
  IsUserLoggedIn,
  getTokenExpiry,
  redirectToLogin,
} from "./utils/login";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";
  const isLoggedIn = IsUserLoggedIn();
  const { pathname } = location;

  useEffect(() => {
    if (!isLoggedIn && pathname !== "/login") {
      navigate("/login");
    }
  }, [isLoggedIn]);

  // Log out as soon as the JWT expires, even if the page is idle
  useEffect(() => {
    if (!isLoggedIn) return;
    const expiry = getTokenExpiry(localStorage.getItem("authorization"));
    // setTimeout overflows above ~24.8 days; re-checked on next navigation anyway
    const delay = Math.min(expiry - Date.now(), 2147483647);
    const timer = setTimeout(redirectToLogin, delay);
    return () => clearTimeout(timer);
  }, [isLoggedIn, pathname]);

  // React.useEffect(() => {
  //   if (isLoggedInCache === "1") {
  //     console.log("inside hereeee");
  //     navigate(from);
  //   } else {
  //     localStorage.removeItem("authorization");
  //     navigate("/login");
  //   }
  // }, [isLoggedInCache, navigate]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="login" element={<LoginPage />} />
          <Route path="org-login" element={<OrganizationGuestRegistration />} />
          <Route path="relation-login" element={<RelationGuest />} />

          <Route element={<RequireAuth allowedRoles={["DATA ENTRY"]} />}>
            <Route path="/" element={<LandingPage />} />
          </Route>

          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  "superadmin",
                  "ERP MANAGER",
                  "MANAGING DIRECTOR",
                  "STORE KEEPER",
                  "HR MANAGER",
                  "CANTEEN INCHARGE",
                  "DESPATCH INCHARGE ",
                  "VEHICLE INCHARGE",
                  "FACTORY MANAGER",
                  "GENERATE BILLING",
                  "DGM",
                ]}
              />
            }
          >
            <Route path="/admin" element={<AdminDashboard />} />
          </Route>
          <Route path="/temp" element={<LandingPage />} />
          <Route path="*" element={<Missing />} />
        </Route>
      </Routes>

      <div className="customToast">
        <ToastContainer
          position="bottom-center"
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          //autoClose={7500}
        />
      </div>
    </>

    //1. Protected Routes. 2. Landing Page UI. 3. Login page. 4 Navigation with header of each topic.
  );
}

export default App;
